<template>
    <div class="container">
        <br/>
        <h2 align="center">Apžiūros aktas</h2><br/>
        <div class="form-group p-0">
            <form method="post" id="register_form" @submit.prevent="handleSubmit" enctype="multipart/form-data">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link tab1 active_tab1" style="border:1px solid #ccc" id="list_object_details">Objektas</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link tab1" id="list_place_details" style="border:1px solid #ccc">Reikalavimai saulės elektrinės montavimui: </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link tab1" id="list_photos" style="border:1px solid #ccc">Būtinosios apžiūros nuotraukos </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link tab1" id="list_apva" style="border:1px solid #ccc">APVA</a>
                    </li>

                </ul>
                <div class="tab-content" style="margin-top:16px;">
                    <div class="tab-pane show active" id="object_details">
                        <div class="card card-default">
                            <div class="card-header">Objektas</div>
                            <div class="card-body">

                                <div class="form-group">
                                    <label for="building_type">Pastato tipas</label>
                                    <select id="roof_type"
                                            v-model="building_type_id"
                                            class="form-control">
                                        <option value="0">Rinktis...</option>
                                        <option :value="building.id" v-for="building in building_types">{{ building.name }}</option>
                                    </select>
                                </div>



                                <div class="form-group">
                                    <label for="input_type">Įvado tipas</label>
                                    <select id="input_type"
                                            v-model="input_type_id"
                                            class="form-control">
                                        <option value="0">Rinktis...</option>
                                        <option :value="i.id" v-for="i in input_types">{{ i.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="input_power">Įvado galia kilovatais</label>
                                    <input id="input_power"
                                           v-model="input_power"
                                           class="form-control"
                                           placeholder="Ivesti įvado galią (kW)">
                                </div>

                                <br/>

                                <div align="center">

                                    <button type="button" name="btn_address_details" id="btn_address_details"
                                            @click="checkObject"
                                            class="btn btn-info btn-lg">Sekantis
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="place_details">
                        <div class="card card-default">
                            <div class="card-header">Monatvimo vieta</div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="roof_status">Kokybė</label>
                                    <select id="roof_status"
                                            v-model="roof_staus_id"
                                            class="form-control">
                                        <option value="0" selected>Rinktis...</option>
                                        <option :value="i.id" v-for="i in roof_statuses">{{ i.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="wire_status">Elektros instaliacijos tinklas</label>
                                    <select id="wire_status"
                                            v-model="wiring_staus_id"
                                            class="form-control">
                                        <option value="0">Rinktis...</option>
                                        <option :value="i.id" v-for="i in wiring_statuses">{{ i.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="inverter_place">Keitiklio vieta</label>
                                    <select id="inverter_place"
                                            v-model="inverter_place_id"
                                            class="form-control">
                                        <option value="0">Rinktis...</option>
                                        <option :value="i.id" v-for="i in inverter_places">{{ i.name }}</option>
                                    </select>
                                </div>



                                <br/>
                                <div align="center">
                                    <button type="button"
                                            @click="backToObject"
                                            id="previous_btn_personal_details" class="btn btn-default btn-lg">Anstesnis
                                    </button>
                                    <button type="button" id="btn_personal_details"
                                            @click="checkPlaceDetails"
                                            class="btn btn-info btn-lg">Sekantis
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="photos">
                        <div class="card card-default">
                            <div class="card-header">Būtinosios apžiūros nuotraukos</div>
                            <div class="card-body">

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <!--skydo foto-->
                                        <div class="form-group">
                                            <label>Paskirstymo skydas</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="skydas" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="skydas">Rinktis failą(-us)</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in skydas_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!--trasos foto-->
                                        <div class="form-group">
                                            <label>Kabelio trasa</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="AC_trasos" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="AC_trasos">Preliminari kabelinė trasa tarp paskirstymo skydo ir numatomos keitiklio montavimo vietos</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in AC_trasos_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!--patalpos nuotrauka-->
                                        <div class="form-group">
                                            <label>Patalpos nuotrauka</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="patalpos" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="patalpos">Patalpos nuotrauka</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in patalpos_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!--Įrangos montavimo vieta (turi būti užfiksuota su Klientu suderinta vieta)-->
                                        <div class="form-group">
                                            <label>Keitiklio montavimo vieta (turi būti užfiksuota su Klientu suderinta vieta)</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="keitiklio_montavimo_vieta" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="keitiklio_montavimo_vieta">Rinktis failą(-us)</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in keitiklio_montavimo_vieta_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!-- Nuolatinės srovės kabelių pravedimo pro pastato sieną į išorę vieta ir kabelių užvedimo ant pastato stogo zona ir montavimo būdas -->
                                        <div class="form-group">
                                            <label>Nuolatinės srovės kabelių pravedimo pro pastato sieną į išorę vieta ir kabelių užvedimo ant pastato stogo zona ir montavimo būdas</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="DC_kabeliu_pravedimas" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="DC_kabeliu_pravedimas">Rinktis failą(-us)</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in DC_kabeliu_pravedimas_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!-- Elektrinės modulių montavimo vieta  -->
                                        <div class="form-group">
                                            <label>Elektrinės modulių montavimo vieta</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="moduliu_montavimo_vieta" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="moduliu_montavimo_vieta">Elektrinės modulių montavimo vieta</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in moduliu_montavimo_vieta_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <!-- Stogo kliūtys -->
                                        <div class="form-group">
                                            <label>Stogo kliūtys</label>
                                            <div class="custom-file my-3">
                                                <input type="file" name="files[]" multiple="multiple" id="stogo_kliutys" class="form-control" @change="handleFileChange"/>
                                                <label class="custom-file-label" for="stogo_kliutys">Stogo kliūtys</label>
                                                <div class="font-weight-bold text-success" v-if="skydas_photo" v-for="file in stogo_kliutys_photo" :key="file.name">Pasirinktas failas: {{ file.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <br/>
                                <div align="center">
                                    <button type="button" name="previous_btn_contact_details"
                                            @click="backToPlace"
                                            id="previous_btn_contact_details" class="btn btn-default btn-lg">Ankstesnis
                                    </button>
                                    <button type="button" name="btn_contact_details" id="btn_contact_details"
                                            @click="checkPhotos"
                                            class="btn btn-info btn-lg">Sekantis
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="apva">
                        <div class="card card-default">
                            <div class="card-header">APVA</div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="inverter_place">APVA</label>
                                    <select id="inverter_place"
                                            v-model="apva_status_id"
                                            class="form-control">
                                        <option value="0">Rinktis...</option>
                                        <option :value="i.id" v-for="i in apva_statuses">{{ i.name }}</option>
                                    </select>
                                </div>

                                <br/>
                                <div align="center">
                                    <button type="button" name="previous_btn_photos"
                                            @click="backToPhotos"
                                            id="previous_btn_contact_details" class="btn btn-default btn-lg">Ankstesnis
                                    </button>
                                    <button type="button" name="btn_contact_details" id="btn_contact_details"
                                            @click="checkApva"
                                            class="btn btn-success btn-lg">Saugoti
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "Inspection",
    props: ['uid', 'cid'],
    data() {
        return {
            roof_type_id: 0,
            building_type_id: 0,
            input_type_id: 0,
            roof_types: [],
            building_types:     [{id: 1, name: 'Gyvenamasis namas'}, {id: 2, name: 'Ūkinis'}, {id: 3, name: 'Priestatas'}, {id: 4, name: 'Žemė'}],
            input_types:        [{id: 1, name: 'Vienfazis'}, {id: 2, name: 'Trifazis  '}],
            input_power:        0,
            roof_statuses:      [{id: 1, name: 'Kokybiška stogo konstrukcija ir danga. Stogo konstrukcija atitinka reikalavimus'}, {id: 2, name: 'Ne tvarkingas'}],
            roof_staus_id:      0,
            wiring_statuses:    [{id: 1, name: 'Tvarkingas elektros instaliacijos tinklas'}, {id: 2, name: 'Ne tvarkingas'}],
            wiring_staus_id:    0,
            inverter_places:    [{id: 1, name: 'Laukas'}, {id: 2, name: 'Pastogė'}, {id: 3, name: 'Vidus'}, {id: 4, name: 'Kita'}],
            inverter_place_id:  0,
            apva_statuses:      [{id: 1, name: 'Užpildyta'}, {id: 2, name: 'Bus pildoma'}, {id: 3, name: 'Patvirtinta'}, {id: 4, name: 'Be paramos'}],
            apva_status_id:     0,

            skydas_photo: [],
            AC_trasos_photo: [],

            patalpos_photo: [],
            keitiklio_montavimo_vieta_photo: [],
            DC_kabeliu_pravedimas_photo: [],

            moduliu_montavimo_vieta_photo: [],
            stogo_kliutys_photo: [],


        }
    },
    methods: {

        handleSubmit() {
            console.log('submit');
        },

        handleFileChange(event) {
            // Access the selected file from the input event
            console.log(event.target.files);
            let inputId = event.target.id;
            const file = event.target.files;

            // Update the data property with the selected file
            // this.skydas_photo = file;
            this.$set(this, inputId + '_photo', file);
        },

        checkObject() {
            if(this.building_type_id > 0 && this.input_type_id > 0 && this.input_power.length > 0) {
                $('#list_object_details').removeClass('active active_tab1');
                $('#object_details').removeClass('active show');
                $('#list_place_details').addClass('active active_tab1');
                $('#place_details').addClass('active show');
            }
        },
        backToObject() {
            $('#list_object_details').addClass('active active_tab1');
            $('#object_details').addClass('active show');
            $('#list_place_details').removeClass('active active_tab1');
            $('#place_details').removeClass('active show');
        },

        checkPlaceDetails() {
            if(this.roof_staus_id > 0 && this.wiring_staus_id > 0 && this.inverter_place_id > 0) {
                $('#list_place_details').removeClass('active active_tab1');
                $('#place_details').removeClass('active show');
                $('#list_photos').addClass('active active_tab1');
                $('#photos').addClass('active show');
            }
        },
        backToPlace() {
            $('#list_place_details').addClass('active active_tab1');
            $('#place_details').addClass('active show');
            $('#list_photos').removeClass('active active_tab1');
            $('#photos').removeClass('active show');
        },


        backToPhotos() {
            $('#list_photos').addClass('active active_tab1');
            $('#photos').addClass('active show');
            $('#list_apva').removeClass('active active_tab1');
            $('#apva').removeClass('active show');
        },



         //check apva and save all form data
        checkApva(e) {
            let save_btn = e.target;
            if(this.apva_status_id > 0) {
                $(save_btn).closest('div').hide();
                this.saveForm();
            }
        },

        //check photos files is selected and save them
        checkPhotos() {
            let all_files_is_set = true;
            document.querySelectorAll('input[type="file"]').forEach(fileInput => {

                let files = fileInput.files;
                if (files.length === 0) {
                    all_files_is_set = false;
                }
            });

            if(all_files_is_set) {
                $('#list_photos').removeClass('active active_tab1');
                $('#photos').removeClass('active show');
                $('#list_apva').addClass('active active_tab1');
                $('#apva').addClass('active show');
            }
        },


        saveForm() {
            //save all form files

            //add these variables to array and send to server
            let json = JSON.stringify(
                {
                    pastato_tipas: this.building_types.find(x => x.id === this.building_type_id).name,
                    ivado_tipas: this.input_types.find(x => x.id === this.input_type_id).name,
                    stogo_bukle: this.roof_statuses.find(x => x.id === this.roof_staus_id).name,
                    instaliacijos_bukle: this.wiring_statuses.find(x => x.id === this.wiring_staus_id).name,
                    inverterio_vieta: this.inverter_places.find(x => x.id === this.inverter_place_id).name,
                    apva: this.apva_statuses.find(x => x.id === this.apva_status_id).name
            });


            document.querySelectorAll('input[type="file"]').forEach(fileInput => {

                const files = fileInput.files;
                const formData = new FormData();

                if (files.length > 0) {
                    Array.from(files).forEach(file => {
                        formData.append('files[]', file);
                    });

                    axios.post('/files', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',  // Set the content type for file upload
                        },
                        params: {
                            customer_id: this.cid,
                            file_name: fileInput.id,
                        },
                    })
                        .then(response => console.log(response))
                        .catch(error => console.error(error));
                }else{
                    console.log('File not selected');
                }
            });

            let form_data = {
                customer_id: this.cid,
                user_id: this.uid,
                data: json
            }

            axios.post('/inspection', form_data)
                .then(response => {
                    console.log(response.data);
                    window.location.replace('/customer/' + this.cid);
                })
                .catch(error => {
                    console.log(error.response.data.message);
                });
        },

    },
    mounted() {
        axios.get('/roof_types')
            .then(response => {
                this.roof_types = response.data;
            })
            .catch(error => {
                let array = {'msg': error.response.data.message};
                window.location.replace('/404');
            });

    }
}
</script>

<style scoped>

.box {
    width: 800px;
    margin: 0 auto;
}

.active_tab1 {
    background-color: #fff !important;
    color: #333 !important;
    font-weight: 600 !important;
}

.tab1 {
    background-color: #f5f5f5;
    color: #333;
    cursor: not-allowed;
}

.has-error {
    border-color: #cc0000;
    background-color: #ffff99;
}

/* Style to position the dropdown below the input */
.dropdown {
    position: relative;
    display: inline-block;
}

input[type="file" i] {
    background-color: chocolate;
    padding: 2px;
}

.dropdown ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 99;
    width: calc(100vw - 100px);
}

.dropdown li {
    padding: 8px;
    border-bottom: 1px solid #ccc;
}

.dropdown li:last-child {
    border-bottom: none;
}

</style>
